import { useMemo } from 'react';
import { ISearchUsedCarsFiltersQuery } from '~/data/types/usedCar/usedCarData';
import { EUrlParam } from '~/data/urlParams';
import { useUsedCarBuildURLParams } from './useUsedCarBuildURLParams';

const useFiltersCounts = (filters: ISearchUsedCarsFiltersQuery) => {
  const globalParams = useUsedCarBuildURLParams();

  const countFilters = useMemo(() => {
    let count = 0;

    // Helper function to check if an object has min and max values
    function isMinMax(obj: any): boolean {
      return (
        obj &&
        typeof obj === 'object' &&
        ('minPrice' in obj ||
          'maxPrice' in obj ||
          'minYear' in obj ||
          'maxYear' in obj)
      );
    }

    for (const key in filters) {
      // Skip fields budget, yearsRange, brands, and models
      if (['budget', 'yearsRange', 'brands', 'models'].includes(key)) {
        continue;
      }

      const value = filters[key as keyof ISearchUsedCarsFiltersQuery];

      // Rule 1: min max is 1 filter
      if (globalParams?.includes(EUrlParam.MIN_KM) && isMinMax(value)) {
        count += 1;
      }
      // Rule 2: true false is 1 filter
      else if (typeof value === 'boolean') {
        count += value ? 1 : 0;
      }
      // Rule 3: array length is the number of filters
      else if (Array.isArray(value)) {
        count += value.length > 0 ? 1 : 0;
      }
    }

    return count;
  }, [filters, globalParams]);

  return countFilters;
};

export default useFiltersCounts;
